module.exports = {
  GOLD: 'gold',
  SILVER: 'silver',
  BRONZE: 'bronze',
};
